import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { GenerateOutputAssetsResult, LabelDataStatusResult, MergeProductLabelsResult } from '../models/download-output/download-output-result';
import { GenerateOutputAssetsRequest } from '../models/download-output/generate-output-assets-request';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
    Accept: 'application/json',
  }),
};

@Injectable({
  providedIn: 'root',
})
export class DownloadOutputService {
  constructor(private http: HttpClient) {}

  downloadOutputProducts(data: { outputFormatIds: string[]; productIds: string[] }): Observable<void> {
    const url = `${environment.apiBase}/products/actions/download-output`;
    return this.http.post<void>(url, data, httpOptions);
  }

  downloadOutputBatch(batchId: string, outputFormatIds: string[]): Observable<void> {
    const url = `${environment.apiBase}/batches/${batchId}/download-output`;
    return this.http.post<void>(url, { outputFormatIds }, httpOptions);
  }

  generateOutputAssets(request: GenerateOutputAssetsRequest): Observable<GenerateOutputAssetsResult> {
    const url = `${environment.apiBase}/products/generate-output-assets`;
    return this.http.post<GenerateOutputAssetsResult>(url, request, httpOptions);
  }

  getLabelDataStatus(productIds: string[]): Observable<LabelDataStatusResult> {
    const url = `${environment.apiBase}/products/actions/label-data-status`;
    return this.http.post<LabelDataStatusResult>(url, { productIds }, httpOptions);
  }

  mergeProductLabels(productIds: string[]): Observable<MergeProductLabelsResult> {
    const url = `${environment.apiBase}/products/actions/merge-labels`;
    return this.http.post<MergeProductLabelsResult>(url, { productIds }, httpOptions);
  }
}
